<template lang="pug">
#compulsory_license
  custom-header(
    :title="certDownload.area01_Title",
    :subTitle="certDownload.area01_SubTitle",
    :image="certDownload.area01_Image",
    :buttonName="certDownload.area01_ButtonName",
    :buttonURL="certDownload.area01_ButtonURL"
  )
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getCerDownload } from "@/json/customer_service";

export default {
  name: "CustomerServiceCompulsoryLicense",
  metaInfo() {
    return {
      title: this.certDownload.SEO_Title,
      meta: [
        { name: "description", content: this.certDownload.SEO_Description },
      ],
    };
  },
  components: {
    "custom-header": CustomHeader,
  },
  data() {
    return {
      certDownload: {},
    };
  },
  created() {
    this.getCerDownload();
  },
  methods: {
    getCerDownload() {
      getCerDownload().then((response) => {
        this.certDownload = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/e_insurance";
</style>
